import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate, translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as settings from "../../constants/settings";
import * as priceTypes from "../../constants/priceTypes";
import * as formatHelper from "../../helpers/formatHelper";
import * as translationHelper from "../../helpers/translationHelper";
import * as getterHelper from "../../helpers/getterHelper";
import * as modelHelper from "../../helpers/modelHelper";
import * as tooltipHelper from "../../helpers/tooltipHelper";
import * as validationHelper from "../../helpers/validationHelper";

import imgLoader from "../../resources/img/loader.svg";
import imgSignal from "../../resources/img/svgicons/signal.svg";
import imgInfo from "../../resources/img/svgicons/info.svg";
import Input from "./generic/Input";
import Table from "./generic/Table";
import CompareColorsSquare from "../../components/apps/default/tab/matchingTab/matchingOptions/CompareColorsSquare";

class CompetitiveColorsPanel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            activeIndex: null,
            focusedDelta: false,
            deltaE: 5,
            product: null,
            fandeck: null,
            priceType: null,
            priceTypeName: null,
            orderBy: 0,
            ascending: true,
            limit: "10",
            formulaList: []
        };
    }

    componentDidMount = () => {
        window.jQuery("#closest-color-1").focus();
        this.setState({formulaList: this.getOrderedFormulaList()});

        let priceType = this.props.priceTypes.find((price) => this.isStandardAndVisible(price));
        if (priceType === undefined) {
            this.setState({
                product: this.props.productId,
                fandeck: this.props.fandeckId
            });
        } else {
            this.setState({
                product: this.props.productId,
                fandeck: this.props.fandeckId,
                priceType: priceType.id,
                priceTypeName: translationHelper.getPriceTypesTranslation(priceType.id)
            });
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.colorList !== this.props.colorList) {
            this.setState({formulaList: this.getOrderedFormulaList(), activeIndex: null});
        }
    }

    isStandardAndVisible = (price) => {
        if (price.id.endsWith("by_name")) {
            return false;
        }

        if (price.id === priceTypes.PRICE_GROUP || price.id === priceTypes.PRICE_GROUP_BARCODE) {
            return false;
        }

        return price.visible;
    };

    getFormulaByIndex = (indexArgument) => {
        return this.state.formulaList.find((_color, index) => index === indexArgument) ?? null;
    };

    selectFormulaByIndex = (index) => {
        let formula = this.getFormulaByIndex(index).formula;
        if (
            formula !== null &&
            (this.props.compFandeckId !== formula.fandeck.id || this.props.compColorId !== formula.color.id)
        ) {
            this.setState({activeIndex: index});
            this.props.selectFandeckAndColor(formula.fandeck, formula.color, formula.delta);
        }
    };

    handleLimitChange = (event) => {
        if (validationHelper.isIntegerValueValid(event.target.value)) {
            this.setState({limit: event.target.value});
        }
    };

    handleLimitBlur = (event) => {
        let limit = event.target.value.trim();

        if (limit.length > 0) {
            this.setState({limit: limit});
        } else {
            this.setState({limit: "10"});
        }

        this.props.reloadColorList(
            this.props.tabId,
            this.props.compFandeckId,
            this.props.compColorId,
            this.state.product,
            this.state.fandeck,
            this.state.deltaE,
            Number(limit),
            this.props.bipp,
            this.props.margin
        );
    };

    handleSelectColorClick = (event) => {
        this.selectFormulaByIndex(Number(event.currentTarget.dataset.key));
    };

    handleDeltaMouseDown = (event) => {
        if (event.target.type !== "range") {
            event.preventDefault();
        }

        if (!this.state.focusedDelta) {
            this.setState({focusedDelta: true});

            setTimeout(function () {
                window.jQuery("#delta-slider").focus();
            }, 300);
        }
    };

    handleDeltaSliderBlur = () => {
        this.setState({focusedDelta: false});
    };

    handleDeltaChange = (event) => {
        event.preventDefault();

        if (!this.props.loading) {
            this.setState({
                deltaE: Number(event.target.value)
            });
        }
    };

    handleDeltaMouseUp = (event) => {
        event.preventDefault();

        if (!this.props.loading) {
            this.props.selectFandeckAndColor(null, null);

            this.setState(
                {
                    activeIndex: null
                },
                this.props.reloadColorList(
                    this.props.tabId,
                    this.props.compFandeckId,
                    this.props.compColorId,
                    this.state.product,
                    this.state.fandeck,
                    Number(event.target.value),
                    Number(this.state.limit),
                    this.props.bipp,
                    this.props.margin
                )
            );
        }
    };

    handleProductChange = (event) => {
        let productId = Number(event.target.value);
        this.props.selectProduct(getterHelper.getObjectById(this.props.simpleProductList, productId));
        this.props.selectFandeckAndColor(null, null);

        this.setState(
            {activeIndex: null, product: productId},
            this.props.reloadColorList(
                this.props.tabId,
                this.props.compFandeckId,
                this.props.compColorId,
                productId,
                this.state.fandeck,
                this.state.deltaE,
                Number(this.state.limit),
                this.props.bipp,
                this.props.margin
            )
        );
    };

    handleFandeckChange = (event) => {
        if (event.target.value === settings.OPTION_NONE) {
            this.props.selectFandeckAndColor(null, null);

            this.setState(
                {activeIndex: null, fandeck: null},
                this.props.reloadColorList(
                    this.props.tabId,
                    this.props.compFandeckId,
                    this.props.compColorId,
                    this.state.product,
                    null,
                    this.state.deltaE,
                    Number(this.state.limit),
                    this.props.bipp,
                    this.props.margin
                )
            );
        } else {
            this.props.selectFandeckAndColor(null, null);

            this.setState(
                {activeIndex: null, fandeck: Number(event.target.value)},
                this.props.reloadColorList(
                    this.props.tabId,
                    this.props.compFandeckId,
                    this.props.compColorId,
                    this.state.product,
                    Number(event.target.value),
                    this.state.deltaE,
                    Number(this.state.limit),
                    this.props.bipp,
                    this.props.margin
                )
            );
        }
    };

    handlePriceTypeChange = (event) => {
        this.setState({
            priceType: event.target.value,
            priceTypeName: translationHelper.getPriceTypesTranslation(event.target.value)
        });
    };

    getDeltaIconClass = (delta) => {
        if (delta < 1) {
            return "range-0";
        }

        if (delta < 2) {
            return "range-1";
        }

        if (delta < 3) {
            return "range-2";
        }

        if (delta < 4) {
            return "range-3";
        }

        if (delta < 5) {
            return "range-4";
        }

        return "range-5";
    };

    getDeltaSelectBoxSlider = () => {
        if (!this.state.focusedDelta) {
            return null;
        }

        return (
            <div className="delta-setting">
                <div className={this.props.loading ? "content disabled" : "content"}>
                    <ReactSVG className="range-0" src={imgSignal} alt="signal" />
                    <input
                        id="delta-slider"
                        className="input-range"
                        type="range"
                        min="1"
                        max="5"
                        step="1"
                        value={this.state.deltaE}
                        onChange={this.handleDeltaChange}
                        onMouseUp={this.handleDeltaMouseUp}
                        onBlur={this.handleDeltaSliderBlur}
                    />
                    <ReactSVG className="range-4" src={imgSignal} alt="signal" />
                </div>
                <footer>
                    <ReactSVG className="info-icon" src={imgInfo} alt="info" />
                    <Translate value="mainTab.lowerDeltaNumber" />
                </footer>
            </div>
        );
    };

    getLimitInput = () => {
        return (
            <div className="cheaper-item margin-right-5 padding-top-5 flex-align-center-vertical">
                <Translate value="general.limit" />:
                <Input
                    className="primary-input width-60px margin-left-5"
                    type="text"
                    value={this.state.limit}
                    onChange={this.handleLimitChange}
                    onBlur={this.handleLimitBlur}
                />
            </div>
        );
    };

    getProductSelectBox = () => {
        let options = [];

        for (let product of this.props.simpleProductList) {
            if (product.enabled) {
                options.push(
                    <option value={product.id} key={product.id}>
                        {product.displayName}
                    </option>
                );
            }
        }

        return (
            <div className="margin-right-5 padding-top-5 flex-align-center-vertical">
                <Translate value="general.product" />:
                <select
                    className="primary-select margin-left-5"
                    value={this.state.product === null ? "" : this.state.product}
                    onChange={this.handleProductChange}
                >
                    {options}
                </select>
            </div>
        );
    };

    getFandeckSelectBox = () => {
        let options = [
            <option value={settings.OPTION_NONE} key={settings.OPTION_NONE}>
                -
            </option>
        ];

        for (let fandeck of this.props.fandeckList) {
            options.push(
                <option value={fandeck.id} key={fandeck.id}>
                    {fandeck.displayName}
                </option>
            );
        }

        return (
            <div className="cheaper-item margin-right-5 padding-top-5 flex-align-center-vertical">
                <Translate value="general.fandeck" />:
                <select
                    className="primary-select margin-left-5"
                    value={this.state.fandeck === null ? settings.OPTION_NONE : this.state.fandeck}
                    onChange={this.handleFandeckChange}
                >
                    {options}
                </select>
            </div>
        );
    };

    getPriceTypesBox = () => {
        if (!this.props.pricing) {
            return null;
        }

        let options = [];

        for (let priceType of this.props.priceTypes) {
            if (this.isStandardAndVisible(priceType)) {
                options.push(
                    <option value={priceType.id} key={priceType.id}>
                        {translationHelper.getPriceTypesTranslation(priceType.id)}
                    </option>
                );
            }
        }

        if (this.state.priceType === null || options.length === 0) {
            return (
                <div>
                    <Translate value="availablePrice.priceType" />: <Translate value="general.noPricesAvailable" />
                </div>
            );
        }

        return (
            <div className="cheaper-item margin-right-5 padding-top-5 flex-align-center-vertical">
                <Translate value="availablePrice.priceType" />:
                <select
                    className="primary-select margin-left-5"
                    value={this.state.priceType}
                    onChange={this.handlePriceTypeChange}
                >
                    {options}
                </select>
            </div>
        );
    };

    getFiltering = () => {
        if (!this.props.filtering) {
            return null;
        }

        return (
            <div className="cheaper-filter col-12 flex flex-wrap flex-align-center-vertical">
                <div className="margin-right-5 padding-top-5 flex flex-align-center-vertical">
                    <Translate value="spectroTab.tolerance" />:
                    <div
                        className="select"
                        style={{height: "auto", padding: 3}}
                        onMouseDown={this.handleDeltaMouseDown}
                    >
                        <div className="">
                            {this.state.deltaE}
                            <span className="glyphicon glyphicon-menu-down select-triangle cursor-pointer padding-left-10"></span>
                        </div>
                        {this.getDeltaSelectBoxSlider()}
                    </div>
                </div>
                {this.getLimitInput()}
                {this.getProductSelectBox()}
                {this.getFandeckSelectBox()}
                {this.getPriceTypesBox()}
            </div>
        );
    };

    getPriceByType = (priceList) => {
        for (let price of priceList) {
            if (price.id === this.state.priceType) {
                return price.price;
            }
        }

        return 0;
    };

    getOrderedFormulaList = () => {
        let colorPriceList = [];

        for (let formula of this.props.colorList) {
            if (formula.priceList !== undefined) {
                colorPriceList.push({
                    formula: formula,
                    price: this.getPriceByType(formula.priceList)
                });
            }
        }

        if (this.state.orderBy === "price") {
            if (this.state.ascending) {
                colorPriceList.sort((a, b) => a.price - b.price);
            } else {
                colorPriceList.sort((a, b) => b.price - a.price);
            }

            return colorPriceList;
        }

        if (!this.state.ascending) {
            colorPriceList.reverse();
        }

        return colorPriceList;
    };

    sortFormulaList = () => {
        this.state.orderBy === 0
            ? this.setState({
                  formulaList: this.state.formulaList.sort((a, b) => {
                      return this.state.ascending
                          ? a.formula.delta < b.formula.delta
                              ? -1
                              : 1
                          : a.formula.delta > b.formula.delta
                            ? -1
                            : 1;
                  })
              })
            : this.setState({
                  formulaList: this.state.formulaList.sort((a, b) => {
                      return this.state.ascending
                          ? a.formula.priceList[0].price < b.formula.priceList[0].price
                              ? -1
                              : 1
                          : a.formula.priceList[0].price > b.formula.priceList[0].price
                            ? -1
                            : 1;
                  })
              });
    };

    cleanSelectedFormula = () => {
        this.setState({activeIndex: null});
        this.props.selectFandeckAndColor(null, null);
    };

    handleSortingChange = (element) => {
        element === this.state.orderBy
            ? this.setState({ascending: !this.state.ascending}, this.sortFormulaList)
            : this.setState({orderBy: element, ascending: true}, this.sortFormulaList);
        this.cleanSelectedFormula();
    };

    getTableHeader = () => {
        let tableHeaderArray = [
            modelHelper.buildTableCell(translate("spectroTab.tolerance")),
            modelHelper.buildTableCell(translate("general.colorPreview")),
            modelHelper.buildTableCell(translate("general.fandeck")),
            modelHelper.buildTableCell(translate("general.colorName"))
        ];
        if (this.props.pricing) {
            tableHeaderArray.push(
                modelHelper.buildModalSection(this.state.priceTypeName ?? translate("general.noPricesAvailable"))
            );
        }
        return modelHelper.buildTableRow(tableHeaderArray);
    };

    getValidTableRows = () => {
        return this.state.formulaList.map((formula, index) => {
            let tableRowss = [
                modelHelper.buildTableCell(
                    formula.formula.delta === 0 ? (
                        <div className="text-center flex flex-align-center-vertical">
                            <ReactSVG
                                className="img-icon-btn flex flex-align-center-vertical padding-right-5"
                                src={imgInfo}
                                alt="info"
                            />
                            <Translate value="keyWords.selectedFormula" />
                        </div>
                    ) : (
                        <ReactSVG
                            className={
                                this.getDeltaIconClass(formula.formula.delta) +
                                " flex flex-align-center-vertical text-center flex-svg"
                            }
                            src={imgSignal}
                            alt="signal"
                            data-text={formatHelper.formatDecimalNumber(formula.formula.delta)}
                            onMouseEnter={tooltipHelper.createTooltip}
                        />
                    ),
                    "flex flex-align-center"
                ),
                modelHelper.buildTableCell(
                    <CompareColorsSquare
                        elementProps={{style: {height: "100%"}}}
                        colors={[this.props.originalRgb, formula.formula.color.rgb]}
                    />,
                    ""
                ),
                modelHelper.buildTableCell(formula.formula.fandeck.name),
                modelHelper.buildTableCell(formula.formula.color.name)
            ];
            if (this.props.pricing) {
                tableRowss.push(
                    modelHelper.buildTableCell(
                        formatHelper.formatCurrency(this.getPriceByType(formula.formula.priceList)),
                        "text-right"
                    )
                );
            }
            return modelHelper.buildTableRow(
                tableRowss,
                (formula.formula.delta === 0 ? "activeRow" : "") +
                    (this.state.activeIndex === index ? " active" : "") +
                    " cursor-pointer",
                index,
                {"data-key": index, onClick: this.handleSelectColorClick}
            );
        });
    };

    getTableColumns = () => {
        return this.props.pricing
            ? [
                  modelHelper.buildTableColumn("col-3 line-height-3_7vh", true),
                  modelHelper.buildTableColumn("col-2 line-height-3_7vh"),
                  modelHelper.buildTableColumn("col-2 line-height-3_7vh flex flex-align-self-center"),
                  modelHelper.buildTableColumn("col-2 line-height-3_7vh flex flex-align-self-center"),
                  modelHelper.buildTableColumn("col-3 line-height-3_7vh flex flex-align-self-center", true)
              ]
            : [
                  modelHelper.buildTableColumn("col-3 line-height-3_7vh", true),
                  modelHelper.buildTableColumn("col-3 line-height-3_7vh"),
                  modelHelper.buildTableColumn("col-3 line-height-3_7vh flex flex-align-self-center"),
                  modelHelper.buildTableColumn("col-3 line-height-3_7vh flex flex-align-self-center")
              ];
    };

    render() {
        return (
            <div className="competitive-search col-12 slim-scroll">
                {this.getFiltering()}
                <Table
                    className="flex-child fill-flex-space"
                    sortingCriterion={this.state.orderBy}
                    sortingAsc={this.state.ascending}
                    onSortingChange={this.handleSortingChange}
                    tableHeader={this.getTableHeader()}
                    tableRows={
                        this.props.loading
                            ? [
                                  modelHelper.buildTableRow([
                                      modelHelper.buildTableCell(
                                          <React.Fragment>
                                              <div className="table-loader text-center">
                                                  <img alt="loader" src={imgLoader} />
                                              </div>
                                          </React.Fragment>,
                                          "col-12"
                                      )
                                  ])
                              ]
                            : this.state.formulaList.length === 0
                              ? [
                                    modelHelper.buildTableRow([
                                        modelHelper.buildTableCell(
                                            translate("mainTab.noResultsFound"),
                                            "col-12 text-center"
                                        )
                                    ])
                                ]
                              : this.getValidTableRows()
                    }
                    tableColumns={this.getTableColumns()}
                />
            </div>
        );
    }
}

export default CompetitiveColorsPanel = connect((store, ownProps) => {
    return {
        simpleProductList: store.global.simpleProductList,
        fandeckList: store.global.fandeckList,
        priceTypes: store.settings.priceTypes,
        loading: store.server.requests.some((request) => request.method === ownProps.method)
    };
})(CompetitiveColorsPanel);
